import script from "./PlayerData.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerData.vue?vue&type=script&setup=true&lang=js"

import "./PlayerData.vue?vue&type=style&index=0&id=3abe2d2c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3abe2d2c"]])

export default __exports__